import React from 'react';
import './OfferBar.css';

export default function OfferBar() {
  return (
    <div className="offer-bar">
      LIMITED TIME ONLY: Get any custom diamond ring with up to 2.0ct diamonds
      for a fixed price of £1499. Complementary travel ring included. Only 20%
      deposit required! T&amp;Cs apply
    </div>
  );
}